var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.084,
    height: 28.8,
    viewBox: "0 0 22.084 28.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medical_Record",
    "data-name": "Medical Record",
    transform: "translate(-299.16 -104.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2982",
    "data-name": "Group 2982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2981",
    "data-name": "Group 2981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2802",
    "data-name": "Path 2802",
    d: "M310.2,106.06a1.312,1.312,0,1,0,1.311,1.312A1.314,1.314,0,0,0,310.2,106.06Zm0,1.78a.468.468,0,1,1,.468-.468A.469.469,0,0,1,310.2,107.84Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2984",
    "data-name": "Group 2984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2983",
    "data-name": "Group 2983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2803",
    "data-name": "Path 2803",
    d: "M306.313,109.208a.422.422,0,0,0-.422.422v.7a.422.422,0,1,0,.843,0v-.7A.421.421,0,0,0,306.313,109.208Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2986",
    "data-name": "Group 2986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2985",
    "data-name": "Group 2985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2804",
    "data-name": "Path 2804",
    d: "M314.091,109.208a.422.422,0,0,0-.422.422v.7a.422.422,0,0,0,.844,0v-.7A.422.422,0,0,0,314.091,109.208Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2988",
    "data-name": "Group 2988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2987",
    "data-name": "Group 2987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2805",
    "data-name": "Path 2805",
    d: "M311.439,109.968a.421.421,0,0,0-.6.039.874.874,0,0,1-1.284,0,.422.422,0,0,0-.636.556,1.719,1.719,0,0,0,2.555,0A.42.42,0,0,0,311.439,109.968Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2990",
    "data-name": "Group 2990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2989",
    "data-name": "Group 2989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2806",
    "data-name": "Path 2806",
    d: "M314.852,121.558h-9.3a.422.422,0,0,0,0,.844h9.3a.422.422,0,0,0,0-.844Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2992",
    "data-name": "Group 2992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2991",
    "data-name": "Group 2991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2807",
    "data-name": "Path 2807",
    d: "M314.852,124.105h-9.3a.421.421,0,1,0,0,.843h9.3a.421.421,0,1,0,0-.843Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2994",
    "data-name": "Group 2994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2993",
    "data-name": "Group 2993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2808",
    "data-name": "Path 2808",
    d: "M314.852,126.651h-9.3a.422.422,0,0,0,0,.844h9.3a.422.422,0,0,0,0-.844Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2996",
    "data-name": "Group 2996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2995",
    "data-name": "Group 2995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2809",
    "data-name": "Path 2809",
    d: "M312.588,115.95h-1.075v-1.075a.421.421,0,0,0-.421-.422h-1.78a.422.422,0,0,0-.422.422v1.075h-1.074a.422.422,0,0,0-.422.422v1.779a.422.422,0,0,0,.422.422h1.074v1.075a.422.422,0,0,0,.422.422h1.78a.421.421,0,0,0,.421-.422v-1.075h1.075a.422.422,0,0,0,.422-.422v-1.779A.422.422,0,0,0,312.588,115.95Zm-.422,1.779h-1.074a.422.422,0,0,0-.422.422v1.075h-.936v-1.075a.422.422,0,0,0-.422-.422h-1.074v-.935h1.074a.422.422,0,0,0,.422-.422V115.3h.936v1.075a.422.422,0,0,0,.422.422h1.074Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2998",
    "data-name": "Group 2998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2997",
    "data-name": "Group 2997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2810",
    "data-name": "Path 2810",
    d: "M318.793,109.028h-1.8v-.663a1.27,1.27,0,0,0-1.269-1.269h-2.632a2.918,2.918,0,0,0-5.775,0h-2.631a1.27,1.27,0,0,0-1.269,1.269v.663h-1.8a2.454,2.454,0,0,0-2.451,2.452v19.469a2.454,2.454,0,0,0,2.451,2.451h2.026a.422.422,0,0,0,0-.844h-2.026A1.61,1.61,0,0,1,300,130.949V111.48a1.61,1.61,0,0,1,1.608-1.608h1.8v1.094h-1.8a.514.514,0,0,0-.514.514v19.469a.514.514,0,0,0,.514.513h17.182a.513.513,0,0,0,.513-.513V111.48a.514.514,0,0,0-.513-.514h-1.8v-1.094h1.8a1.609,1.609,0,0,1,1.607,1.608v19.469a1.609,1.609,0,0,1-1.607,1.607H305.324a.422.422,0,0,0,0,.844h13.469a2.454,2.454,0,0,0,2.451-2.451V111.48A2.455,2.455,0,0,0,318.793,109.028Zm-.33,2.782v18.809H301.941V111.81h1.473v.09a1.271,1.271,0,0,0,1.269,1.269h8.179a.422.422,0,0,0,0-.844h-8.179a.426.426,0,0,1-.426-.425v-3.535a.426.426,0,0,1,.426-.425h3.023a.422.422,0,0,0,.422-.422,2.074,2.074,0,0,1,4.148,0,.422.422,0,0,0,.422.422h3.023a.425.425,0,0,1,.425.425V111.9a.425.425,0,0,1-.425.425h-1.172a.422.422,0,0,0,0,.844h1.172a1.27,1.27,0,0,0,1.269-1.269v-.09Z",
    fill: "#6c5b7b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalRecord);
export default __webpack_public_path__ + "static/media/Medical-record.27b831a2de9bf0bfcbdf0506dbc01d31.svg";
export { ForwardRef as ReactComponent };